import React, {useRef} from "react";

import {
  LimitCheckProps,
  LimitCheckWithInstantCheckout,
  LimitCheckWithInstantCheckoutComponent,
} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

export const LimitCheckLocationTierLimit = React.forwardRef((_, ref) => {
  const checkerRef = useRef<LimitCheckWithInstantCheckoutComponent>();
  const checkIfLimitHit = (props?: LimitCheckProps) => {
    return checkerRef.current?.checkIfLimitHit(props);
  };
  React.useImperativeHandle(ref, () => ({
    checkIfLimitHit,
  }));
  return (
    <LimitCheckWithInstantCheckout
      getUpgradeMessage={(hasSubscription) =>
        `${!hasSubscription ? "Subscribe" : "Upgrade"} now to allocate this Check location to your account.`
      }
      getRequestMessage={(hasSubscription) =>
        `If you would like to ${!hasSubscription ? "request a subscription" : "upgrade your account"} to allocate this Check location to your account, please send a request to the owner of this account below to upgrade.`
      }
      getReasonMessage={(hasSubscription, limitName) =>
        !hasSubscription
          ? `The Check location \`${limitName}\` is not available on your Free Trial`
          : `The Check location \`${limitName}\` is not available on your current plan`
      }
      getTitleMessage={(hasSubscription) => `${hasSubscription ? "Upgrade" : "Subscribe"} to add this Check location`}
      limitField="limit_monitoring_group_level"
      ref={checkerRef}
    />
  );
});
